module.exports = __webpack_public_path__ + "img/loading.527f7835.gif";